<template>
  <el-tabs v-model="activeName">
    <el-tab-pane label="Common" name="common">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        v-loading="isBusy"
        element-loading-spinner="el-icon-loading"
        label-width="205px"
      >
        <el-form-item label="Title" prop="title">
          <el-input v-model="form.title" placeholder="Title"></el-input>
        </el-form-item>
        <el-form-item label="Name" prop="name">
          <el-input v-model="form.name" placeholder="Name"></el-input>
        </el-form-item>
        <el-form-item label="Brand" prop="brand_id">
          <el-select v-model="form.brand_id" class="w-100">
            <el-option
              v-for="option in brandOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Representative" prop="representative_id">
          <el-select v-model="form.representative_id" class="w-100">
            <el-option
              v-for="option in representativeOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Provider" prop="provider_id">
          <el-select v-model="form.provider_id" class="w-100">
            <el-option
              v-for="option in providerList"
              :key="option.id"
              :label="option.name"
              :value="option.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Email Address" prop="email_address_id">
          <el-select v-model="form.email_address_id" class="w-100">
            <el-option
              v-for="option in emailAddressList"
              :key="option.id"
              :label="option.address"
              :value="option.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Phone Number" prop="phone_number">
          <el-input
            v-model="form.phone_number"
            placeholder="Phone Number"
          ></el-input>
        </el-form-item>
        <el-form-item label="Reject all inbound calls" prop="reject_calls">
          <el-switch v-model="form.reject_calls"></el-switch>
        </el-form-item>
        <el-form-item
          label="Allow unapproved messages"
          prop="allow_unapproved_messages"
        >
          <el-switch v-model="form.allow_unapproved_messages"></el-switch>
        </el-form-item>
      </el-form>
      <button class="btn btn-create px-4" @click="store">Store</button>
    </el-tab-pane>
    <el-tab-pane label="User Bindings" name="binding" :disabled="!isEditMode">
      <users-table :url="usersIndexUrl"></users-table>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import BaseForm from "../form";
import UsersTable from "./users/table";

export default {
  extends: BaseForm,

  props: {
    brandList: Array,
    usersIndexUrl: String,
    providerList: Array,
    representativeList: Array,
    emailAddressList: Array,
  },

  components: {
    UsersTable,
  },

  data() {
    const form = {
      title: null,
      name: null,
      brand_id: null,
      phone_number: null,
      provider_id: null,
      representative_id: null,
      email_address_id: null,
      reject_calls: false,
      allow_unapproved_messages: false,
    };

    return {
      form,
      rules: _.mapValues(form, () => [
        { validator: this.fieldExternalValidator },
      ]),
      activeName: "common",
    };
  },

  computed: {
    /**
     * @return {Array}
     */
    brandOptions() {
      return _.map(this.brandList, (item, key) => {
        return { label: item.title, value: item.id };
      });
    },

    /**
     * @return {Array}
     */
    representativeOptions() {
      return _.map(this.representativeList, (item, key) => {
        return { label: item.name, value: item.id };
      });
    },
  },

  methods: {
    /**
     * @param {Object} model
     */
    initForm(model) {
      this.form = _.mapValues(this.form, (val, prop) =>
        _.get(model, prop, null)
      );
    },
  },
};
</script>
